/**
 * Astrology Calculator Logic
 * 基于 Astronomy Engine 的占星计算
 * 需要先引入 astronomy.browser.min.js
 */

(function(global) {
  'use strict';

  // ============ 基础数据 ============

  // 黄道十二宫
  const ZODIAC_SIGNS = [
    { index: 0, name: '白羊座', nameEn: 'Aries', symbol: '♈', element: '火', modality: '开创', ruler: '火星', startDegree: 0 },
    { index: 1, name: '金牛座', nameEn: 'Taurus', symbol: '♉', element: '土', modality: '固定', ruler: '金星', startDegree: 30 },
    { index: 2, name: '双子座', nameEn: 'Gemini', symbol: '♊', element: '风', modality: '变动', ruler: '水星', startDegree: 60 },
    { index: 3, name: '巨蟹座', nameEn: 'Cancer', symbol: '♋', element: '水', modality: '开创', ruler: '月亮', startDegree: 90 },
    { index: 4, name: '狮子座', nameEn: 'Leo', symbol: '♌', element: '火', modality: '固定', ruler: '太阳', startDegree: 120 },
    { index: 5, name: '处女座', nameEn: 'Virgo', symbol: '♍', element: '土', modality: '变动', ruler: '水星', startDegree: 150 },
    { index: 6, name: '天秤座', nameEn: 'Libra', symbol: '♎', element: '风', modality: '开创', ruler: '金星', startDegree: 180 },
    { index: 7, name: '天蝎座', nameEn: 'Scorpio', symbol: '♏', element: '水', modality: '固定', ruler: '冥王星', startDegree: 210 },
    { index: 8, name: '射手座', nameEn: 'Sagittarius', symbol: '♐', element: '火', modality: '变动', ruler: '木星', startDegree: 240 },
    { index: 9, name: '摩羯座', nameEn: 'Capricorn', symbol: '♑', element: '土', modality: '开创', ruler: '土星', startDegree: 270 },
    { index: 10, name: '水瓶座', nameEn: 'Aquarius', symbol: '♒', element: '风', modality: '固定', ruler: '天王星', startDegree: 300 },
    { index: 11, name: '双鱼座', nameEn: 'Pisces', symbol: '♓', element: '水', modality: '变动', ruler: '海王星', startDegree: 330 }
  ];

  // 行星
  const PLANETS = [
    { id: 'Sun', name: '太阳', symbol: '☉', type: 'luminary', weight: 10 },
    { id: 'Moon', name: '月亮', symbol: '☽', type: 'luminary', weight: 10 },
    { id: 'Mercury', name: '水星', symbol: '☿', type: 'personal', weight: 6 },
    { id: 'Venus', name: '金星', symbol: '♀', type: 'personal', weight: 6 },
    { id: 'Mars', name: '火星', symbol: '♂', type: 'personal', weight: 6 },
    { id: 'Jupiter', name: '木星', symbol: '♃', type: 'social', weight: 4 },
    { id: 'Saturn', name: '土星', symbol: '♄', type: 'social', weight: 4 },
    { id: 'Uranus', name: '天王星', symbol: '♅', type: 'transpersonal', weight: 2 },
    { id: 'Neptune', name: '海王星', symbol: '♆', type: 'transpersonal', weight: 2 },
    { id: 'Pluto', name: '冥王星', symbol: '♇', type: 'transpersonal', weight: 2 }
  ];

  // 相位
  const ASPECTS = [
    { name: '合相', nameEn: 'Conjunction', angle: 0, orb: 8, symbol: '☌', nature: 'major', color: '#e74c3c' },
    { name: '六分相', nameEn: 'Sextile', angle: 60, orb: 5, symbol: '⚹', nature: 'harmonious', color: '#3498db' },
    { name: '刑相', nameEn: 'Square', angle: 90, orb: 7, symbol: '□', nature: 'challenging', color: '#e74c3c' },
    { name: '三分相', nameEn: 'Trine', angle: 120, orb: 7, symbol: '△', nature: 'harmonious', color: '#2ecc71' },
    { name: '对分相', nameEn: 'Opposition', angle: 180, orb: 8, symbol: '☍', nature: 'challenging', color: '#e74c3c' },
    { name: '十二分相', nameEn: 'Semi-sextile', angle: 30, orb: 2, symbol: '⚺', nature: 'minor', color: '#95a5a6' },
    { name: '梅花相', nameEn: 'Quincunx', angle: 150, orb: 3, symbol: '⚻', nature: 'minor', color: '#9b59b6' }
  ];

  // 十二宫位
  const HOUSES = [
    { number: 1, name: '命宫', theme: '自我、外表、第一印象、人格面具' },
    { number: 2, name: '财帛宫', theme: '金钱、物质、自我价值、资源' },
    { number: 3, name: '兄弟宫', theme: '沟通、学习、短途旅行、兄弟姐妹' },
    { number: 4, name: '田宅宫', theme: '家庭、根源、内心深处、房产' },
    { number: 5, name: '子女宫', theme: '创造力、恋爱、娱乐、子女' },
    { number: 6, name: '奴仆宫', theme: '健康、工作、日常事务、服务' },
    { number: 7, name: '夫妻宫', theme: '婚姻、合作、一对一关系、公开敌人' },
    { number: 8, name: '疾厄宫', theme: '死亡重生、共享资源、性、心理深度' },
    { number: 9, name: '迁移宫', theme: '高等教育、远行、哲学、信仰' },
    { number: 10, name: '官禄宫', theme: '事业、社会地位、名声、人生目标' },
    { number: 11, name: '福德宫', theme: '朋友、团体、希望、社会理想' },
    { number: 12, name: '玄秘宫', theme: '潜意识、隐藏、灵性、业力' }
  ];

  // 行星解读关键词
  const PLANET_MEANINGS = {
    Sun: { keyword: '核心自我', description: '代表你的核心身份、生命力和自我表达方式' },
    Moon: { keyword: '情感需求', description: '代表你的情绪、直觉、内在需求和安全感' },
    Mercury: { keyword: '思维沟通', description: '代表你的思维方式、沟通风格和学习能力' },
    Venus: { keyword: '爱与美', description: '代表你的爱情观、审美品味和价值观' },
    Mars: { keyword: '行动力', description: '代表你的行动方式、欲望和竞争性' },
    Jupiter: { keyword: '扩展与幸运', description: '代表你的成长方向、信仰和机遇' },
    Saturn: { keyword: '责任与限制', description: '代表你的责任感、恐惧和人生功课' },
    Uranus: { keyword: '变革与独立', description: '代表你的独特性、叛逆和突破领域' },
    Neptune: { keyword: '梦想与灵性', description: '代表你的想象力、灵性追求和幻想' },
    Pluto: { keyword: '转化与力量', description: '代表你的深层转化、权力欲和重生领域' }
  };

  // ============ 核心计算函数 ============

  /**
   * 规范化角度到 0-360
   */
  function normalizeDegrees(deg) {
    deg = deg % 360;
    if (deg < 0) deg += 360;
    return deg;
  }

  /**
   * 将黄经度数转换为星座信息
   */
  function longitudeToSign(longitude) {
    // 确保在 0-360 范围内
    longitude = normalizeDegrees(longitude);
    
    const signIndex = Math.floor(longitude / 30);
    const degree = longitude % 30;
    
    // 安全检查
    if (signIndex < 0 || signIndex >= 12) {
      console.warn('Invalid sign index:', signIndex, 'from longitude:', longitude);
      return {
        sign: ZODIAC_SIGNS[0],
        signIndex: 0,
        longitude: longitude,
        degree: 0,
        minute: 0,
        second: 0
      };
    }
    
    return {
      sign: ZODIAC_SIGNS[signIndex],
      signIndex: signIndex,
      longitude: longitude,
      degree: Math.floor(degree),
      minute: Math.floor((degree % 1) * 60),
      second: Math.floor(((degree % 1) * 60 % 1) * 60)
    };
  }

  /**
   * 格式化度数显示
   */
  function formatDegree(longitude) {
    const info = longitudeToSign(longitude);
    return `${info.degree}°${info.sign.symbol}${info.minute}'`;
  }

  /**
   * 获取儒略日
   */
  function getJulianDay(date) {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth() + 1;
    const day = date.getUTCDate();
    const hour = date.getUTCHours() + date.getUTCMinutes() / 60 + date.getUTCSeconds() / 3600;
    
    let y = year;
    let m = month;
    
    if (m <= 2) {
      y -= 1;
      m += 12;
    }
    
    const A = Math.floor(y / 100);
    const B = 2 - A + Math.floor(A / 4);
    
    const JD = Math.floor(365.25 * (y + 4716)) + 
               Math.floor(30.6001 * (m + 1)) + 
               day + hour / 24 + B - 1524.5;
    
    return JD;
  }

  /**
   * 计算恒星时
   */
  function calculateSiderealTime(date, longitude) {
    const JD = getJulianDay(date);
    const T = (JD - 2451545.0) / 36525;
    
    let GMST = 280.46061837 + 360.98564736629 * (JD - 2451545.0) + 
               0.000387933 * T * T - T * T * T / 38710000;
    
    GMST = normalizeDegrees(GMST);
    const LST = normalizeDegrees(GMST + longitude);
    
    return LST;
  }

  /**
   * 计算上升点
   */
  function calculateAscendant(date, latitude, longitude) {
    const LST = calculateSiderealTime(date, longitude);
    const RAMC = LST;
    
    const JD = getJulianDay(date);
    const T = (JD - 2451545.0) / 36525;
    const obliquity = 23.439291 - 0.0130042 * T;
    
    const latRad = latitude * Math.PI / 180;
    const oblRad = obliquity * Math.PI / 180;
    const ramcRad = RAMC * Math.PI / 180;
    
    let ascendant = Math.atan2(
      Math.cos(ramcRad),
      -(Math.sin(ramcRad) * Math.cos(oblRad) + Math.tan(latRad) * Math.sin(oblRad))
    ) * 180 / Math.PI;
    
    ascendant = normalizeDegrees(ascendant);
    
    return ascendant;
  }

  /**
   * 计算中天 (MC)
   */
  function calculateMidheaven(date, longitude) {
    const LST = calculateSiderealTime(date, longitude);
    
    const JD = getJulianDay(date);
    const T = (JD - 2451545.0) / 36525;
    const obliquity = 23.439291 - 0.0130042 * T;
    
    const oblRad = obliquity * Math.PI / 180;
    const lstRad = LST * Math.PI / 180;
    
    let mc = Math.atan2(Math.sin(lstRad), Math.cos(lstRad) * Math.cos(oblRad)) * 180 / Math.PI;
    mc = normalizeDegrees(mc);
    
    return mc;
  }

  /**
   * 使用 Astronomy Engine 计算行星位置
   */
  function calculatePlanetPositions(date) {
    const positions = {};
    
    if (typeof Astronomy === 'undefined') {
      console.error('Astronomy Engine not loaded, using fallback calculation');
      return calculatePlanetPositionsFallback(date);
    }
    
    try {
      const time = Astronomy.MakeTime(date);
      
      // 太阳 - 使用 SunPosition
      try {
        const sun = Astronomy.SunPosition(time);
        positions.Sun = normalizeDegrees(sun.elon);
      } catch (e) {
        console.warn('Sun calculation error:', e);
        positions.Sun = calculateSunLongitude(date);
      }
      
      // 月亮 - 使用 EclipticGeoMoon
      try {
        const moon = Astronomy.EclipticGeoMoon(time);
        positions.Moon = normalizeDegrees(moon.lon);
      } catch (e) {
        console.warn('Moon calculation error:', e);
        positions.Moon = calculateMoonLongitude(date);
      }
      
      // 其他行星
      const planetBodies = {
        'Mercury': Astronomy.Body.Mercury,
        'Venus': Astronomy.Body.Venus,
        'Mars': Astronomy.Body.Mars,
        'Jupiter': Astronomy.Body.Jupiter,
        'Saturn': Astronomy.Body.Saturn,
        'Uranus': Astronomy.Body.Uranus,
        'Neptune': Astronomy.Body.Neptune,
        'Pluto': Astronomy.Body.Pluto
      };
      
      for (const [name, body] of Object.entries(planetBodies)) {
        try {
          // 获取地心赤道坐标
          const equ = Astronomy.Equator(body, time, Astronomy.Observer(0, 0, 0), true, true);
          // 转换为黄道坐标
          const ecl = Astronomy.Ecliptic(equ.vec);
          positions[name] = normalizeDegrees(ecl.elon);
        } catch (e) {
          console.warn(`${name} calculation error:`, e);
          // 使用后备计算
          positions[name] = calculatePlanetFallback(name, date);
        }
      }
      
    } catch (e) {
      console.error('Astronomy Engine error:', e);
      return calculatePlanetPositionsFallback(date);
    }
    
    return positions;
  }

  /**
   * 后备：简化的太阳黄经计算
   */
  function calculateSunLongitude(date) {
    const JD = getJulianDay(date);
    const T = (JD - 2451545.0) / 36525;
    
    const L0 = 280.4664567 + 360007.6982779 * T / 360;
    const M = 357.5291092 + 35999.0502909 * T;
    const MRad = M * Math.PI / 180;
    
    const C = 1.9146 * Math.sin(MRad) + 0.02 * Math.sin(2 * MRad);
    
    return normalizeDegrees(L0 + C);
  }

  /**
   * 后备：简化的月亮黄经计算
   */
  function calculateMoonLongitude(date) {
    const JD = getJulianDay(date);
    const T = (JD - 2451545.0) / 36525;
    
    const L = 218.3164591 + 481267.88134236 * T;
    const M = 134.9634114 + 477198.8676313 * T;
    const MRad = M * Math.PI / 180;
    
    const correction = 6.29 * Math.sin(MRad);
    
    return normalizeDegrees(L + correction);
  }

  /**
   * 后备：简化的行星黄经计算
   */
  function calculatePlanetFallback(planet, date) {
    const JD = getJulianDay(date);
    const T = (JD - 2451545.0) / 36525;
    
    // 简化的平黄经（仅供参考，精度有限）
    const meanLongitudes = {
      'Mercury': 252.2509 + 149474.0722 * T,
      'Venus': 181.9798 + 58519.2130 * T,
      'Mars': 355.4330 + 19141.6964 * T,
      'Jupiter': 34.3515 + 3036.3027 * T,
      'Saturn': 50.0774 + 1223.5110 * T,
      'Uranus': 314.0550 + 429.8640 * T,
      'Neptune': 304.3487 + 219.8833 * T,
      'Pluto': 238.9289 + 146.0541 * T
    };
    
    return normalizeDegrees(meanLongitudes[planet] || 0);
  }

  /**
   * 完全后备的行星位置计算（不依赖 Astronomy Engine）
   */
  function calculatePlanetPositionsFallback(date) {
    return {
      Sun: calculateSunLongitude(date),
      Moon: calculateMoonLongitude(date),
      Mercury: calculatePlanetFallback('Mercury', date),
      Venus: calculatePlanetFallback('Venus', date),
      Mars: calculatePlanetFallback('Mars', date),
      Jupiter: calculatePlanetFallback('Jupiter', date),
      Saturn: calculatePlanetFallback('Saturn', date),
      Uranus: calculatePlanetFallback('Uranus', date),
      Neptune: calculatePlanetFallback('Neptune', date),
      Pluto: calculatePlanetFallback('Pluto', date)
    };
  }

  /**
   * 计算宫位（等宫制）
   */
  function calculateHouses(ascendant, mc) {
    const houses = [];
    
    for (let i = 0; i < 12; i++) {
      const cusp = normalizeDegrees(ascendant + i * 30);
      const signInfo = longitudeToSign(cusp);
      
      houses.push({
        number: i + 1,
        cusp: cusp,
        sign: signInfo.sign,
        degree: signInfo.degree,
        minute: signInfo.minute,
        ...HOUSES[i]
      });
    }
    
    // 修正 MC 到第10宫
    houses[9].cusp = mc;
    const mcSign = longitudeToSign(mc);
    houses[9].sign = mcSign.sign;
    houses[9].degree = mcSign.degree;
    houses[9].minute = mcSign.minute;
    
    // IC 是 MC 的对面（第4宫）
    const ic = normalizeDegrees(mc + 180);
    houses[3].cusp = ic;
    const icSign = longitudeToSign(ic);
    houses[3].sign = icSign.sign;
    houses[3].degree = icSign.degree;
    houses[3].minute = icSign.minute;
    
    return houses;
  }

  /**
   * 判断行星落在哪个宫位
   */
  function getPlanetHouse(planetLongitude, houses) {
    planetLongitude = normalizeDegrees(planetLongitude);
    
    for (let i = 0; i < 12; i++) {
      const currentCusp = houses[i].cusp;
      const nextCusp = houses[(i + 1) % 12].cusp;
      
      let inHouse = false;
      if (nextCusp > currentCusp) {
        inHouse = planetLongitude >= currentCusp && planetLongitude < nextCusp;
      } else {
        inHouse = planetLongitude >= currentCusp || planetLongitude < nextCusp;
      }
      
      if (inHouse) {
        return i + 1;
      }
    }
    return 1;
  }

  /**
   * 计算两点之间的相位
   */
  function calculateAspect(long1, long2) {
    long1 = normalizeDegrees(long1);
    long2 = normalizeDegrees(long2);
    
    let diff = Math.abs(long1 - long2);
    if (diff > 180) diff = 360 - diff;
    
    for (const aspect of ASPECTS) {
      const orb = Math.abs(diff - aspect.angle);
      if (orb <= aspect.orb) {
        return {
          aspect: aspect,
          orb: orb,
          isExact: orb < 1,
          isApplying: null
        };
      }
    }
    return null;
  }

  /**
   * 计算所有行星之间的相位
   */
  function calculateAllAspects(planetPositions, includePoints = {}) {
    const aspects = [];
    const allPoints = { ...planetPositions, ...includePoints };
    const pointNames = Object.keys(allPoints);
    
    for (let i = 0; i < pointNames.length; i++) {
      for (let j = i + 1; j < pointNames.length; j++) {
        const name1 = pointNames[i];
        const name2 = pointNames[j];
        const pos1 = allPoints[name1];
        const pos2 = allPoints[name2];
        
        // 检查值是否有效
        if (typeof pos1 !== 'number' || typeof pos2 !== 'number' || isNaN(pos1) || isNaN(pos2)) {
          continue;
        }
        
        const aspectResult = calculateAspect(pos1, pos2);
        if (aspectResult) {
          aspects.push({
            planet1: name1,
            planet2: name2,
            ...aspectResult
          });
        }
      }
    }
    
    return aspects;
  }

  /**
   * 统计元素和模式分布
   */
  function calculateDistribution(planetPositions) {
    const elements = { '火': 0, '土': 0, '风': 0, '水': 0 };
    const modalities = { '开创': 0, '固定': 0, '变动': 0 };
    
    const weights = {
      Sun: 2, Moon: 2, Mercury: 1.5, Venus: 1.5, Mars: 1.5,
      Jupiter: 1, Saturn: 1, Uranus: 0.5, Neptune: 0.5, Pluto: 0.5
    };
    
    Object.entries(planetPositions).forEach(([planet, longitude]) => {
      // 安全检查
      if (typeof longitude !== 'number' || isNaN(longitude)) {
        console.warn(`Invalid longitude for ${planet}:`, longitude);
        return;
      }
      
      const signInfo = longitudeToSign(longitude);
      
      // 再次安全检查
      if (!signInfo || !signInfo.sign) {
        console.warn(`Invalid sign info for ${planet}:`, signInfo);
        return;
      }
      
      const weight = weights[planet] || 1;
      
      if (signInfo.sign.element && elements[signInfo.sign.element] !== undefined) {
        elements[signInfo.sign.element] += weight;
      }
      
      if (signInfo.sign.modality && modalities[signInfo.sign.modality] !== undefined) {
        modalities[signInfo.sign.modality] += weight;
      }
    });
    
    return { elements, modalities };
  }

  /**
   * 获取主导元素
   */
  function getDominantElement(elements) {
    let max = 0;
    let dominant = '火';
    for (const [el, count] of Object.entries(elements)) {
      if (count > max) {
        max = count;
        dominant = el;
      }
    }
    return dominant;
  }

  /**
   * 获取主导模式
   */
  function getDominantModality(modalities) {
    let max = 0;
    let dominant = '开创';
    for (const [mod, count] of Object.entries(modalities)) {
      if (count > max) {
        max = count;
        dominant = mod;
      }
    }
    return dominant;
  }

  // ============ 主要导出函数 ============

  /**
   * 计算完整的本命星盘
   */
  function calculateNatalChart(year, month, day, hour, minute, latitude, longitude, timezone) {
    // 构建 UTC 时间
    const localDate = new Date(year, month - 1, day, hour, minute);
    const utcDate = new Date(localDate.getTime() - timezone * 60 * 60 * 1000);
    
    console.log('Calculating chart for:', utcDate.toISOString());
    
    // 计算行星位置
    const planetPositions = calculatePlanetPositions(utcDate);
    console.log('Planet positions:', planetPositions);
    
    // 计算上升点和中天
    const ascendant = calculateAscendant(utcDate, latitude, longitude);
    const midheaven = calculateMidheaven(utcDate, longitude);
    
    console.log('Ascendant:', ascendant, 'MC:', midheaven);
    
    // 计算宫位
    const houses = calculateHouses(ascendant, midheaven);
    
    // 计算相位
    const aspects = calculateAllAspects(planetPositions, {
      'ASC': ascendant,
      'MC': midheaven
    });
    
    // 统计分布
    const { elements, modalities } = calculateDistribution(planetPositions);
    
    // 整理行星数据
    const planets = {};
    PLANETS.forEach(planetInfo => {
      const id = planetInfo.id;
      const longitude = planetPositions[id];
      
      if (typeof longitude === 'number' && !isNaN(longitude)) {
        const signInfo = longitudeToSign(longitude);
        const house = getPlanetHouse(longitude, houses);
        
        planets[id] = {
          ...planetInfo,
          longitude,
          sign: signInfo.sign,
          degree: signInfo.degree,
          minute: signInfo.minute,
          house,
          formatted: formatDegree(longitude),
          meaning: PLANET_MEANINGS[id]
        };
      }
    });
    
    // 上升点信息
    const ascInfo = longitudeToSign(ascendant);
    const mcInfo = longitudeToSign(midheaven);
    
    return {
      // 出生数据
      birthData: {
        year, month, day, hour, minute,
        latitude, longitude, timezone,
        utcDate
      },
      
      // 核心点
      ascendant: {
        longitude: ascendant,
        sign: ascInfo.sign,
        degree: ascInfo.degree,
        minute: ascInfo.minute,
        formatted: formatDegree(ascendant)
      },
      midheaven: {
        longitude: midheaven,
        sign: mcInfo.sign,
        degree: mcInfo.degree,
        minute: mcInfo.minute,
        formatted: formatDegree(midheaven)
      },
      
      // 行星
      planets,
      planetPositions,
      
      // 宫位
      houses,
      
      // 相位
      aspects,
      
      // 统计
      elements,
      modalities,
      dominantElement: getDominantElement(elements),
      dominantModality: getDominantModality(modalities),
      
      // 快捷访问
      sunSign: planets.Sun?.sign?.name || '未知',
      moonSign: planets.Moon?.sign?.name || '未知',
      risingSign: ascInfo.sign?.name || '未知',
      
      // 元数据
      ZODIAC_SIGNS,
      PLANETS,
      ASPECTS,
      HOUSES
    };
  }

  /**
   * 计算合盘（双人比较）
   */
  function calculateSynastry(chartA, chartB) {
    const crossAspects = [];
    
    // 计算 A 的行星与 B 的行星之间的相位
    Object.entries(chartA.planetPositions).forEach(([planetA, longA]) => {
      if (typeof longA !== 'number' || isNaN(longA)) return;
      
      Object.entries(chartB.planetPositions).forEach(([planetB, longB]) => {
        if (typeof longB !== 'number' || isNaN(longB)) return;
        
        const aspectResult = calculateAspect(longA, longB);
        if (aspectResult) {
          crossAspects.push({
            planetA,
            planetB,
            personA: 'A',
            personB: 'B',
            ...aspectResult
          });
        }
      });
    });
    
    // A的行星与B的四轴
    ['ASC', 'MC'].forEach(axis => {
      const longB = axis === 'ASC' ? chartB.ascendant.longitude : chartB.midheaven.longitude;
      Object.entries(chartA.planetPositions).forEach(([planetA, longA]) => {
        if (typeof longA !== 'number' || isNaN(longA)) return;
        
        const aspectResult = calculateAspect(longA, longB);
        if (aspectResult) {
          crossAspects.push({
            planetA,
            planetB: axis,
            personA: 'A',
            personB: 'B',
            ...aspectResult
          });
        }
      });
    });
    
    // B的行星与A的四轴
    ['ASC', 'MC'].forEach(axis => {
      const longA = axis === 'ASC' ? chartA.ascendant.longitude : chartA.midheaven.longitude;
      Object.entries(chartB.planetPositions).forEach(([planetB, longB]) => {
        if (typeof longB !== 'number' || isNaN(longB)) return;
        
        const aspectResult = calculateAspect(longA, longB);
        if (aspectResult) {
          crossAspects.push({
            planetA: axis,
            planetB,
            personA: 'A',
            personB: 'B',
            ...aspectResult
          });
        }
      });
    });
    
    // 元素兼容性
    const elementCompatibility = calculateElementCompatibility(chartA.elements, chartB.elements);
    
    // 综合评分
    const score = calculateSynastryScore(crossAspects, elementCompatibility);
    
    return {
      chartA,
      chartB,
      crossAspects,
      elementCompatibility,
      score,
      
      sunSunAspect: findAspect(crossAspects, 'Sun', 'Sun'),
      moonMoonAspect: findAspect(crossAspects, 'Moon', 'Moon'),
      venusMarsAspect: findAspect(crossAspects, 'Venus', 'Mars') || findAspect(crossAspects, 'Mars', 'Venus')
    };
  }

  /**
   * 计算元素兼容性
   */
  function calculateElementCompatibility(elementsA, elementsB) {
    const compatible = {
      '火': ['火', '风'],
      '风': ['风', '火'],
      '土': ['土', '水'],
      '水': ['水', '土']
    };
    
    const dominantA = getDominantElement(elementsA);
    const dominantB = getDominantElement(elementsB);
    
    const isCompatible = compatible[dominantA]?.includes(dominantB);
    
    return {
      dominantA,
      dominantB,
      isCompatible,
      description: isCompatible 
        ? `${dominantA}象与${dominantB}象天然相容，能量互补` 
        : `${dominantA}象与${dominantB}象需要更多理解与适应`
    };
  }

  /**
   * 查找特定相位
   */
  function findAspect(aspects, planet1, planet2) {
    return aspects.find(a => 
      (a.planetA === planet1 && a.planetB === planet2) ||
      (a.planetA === planet2 && a.planetB === planet1)
    );
  }

  /**
   * 计算合盘评分
   */
  function calculateSynastryScore(crossAspects, elementCompatibility) {
    let score = 60;
    
    crossAspects.forEach(aspect => {
      const weight = getAspectWeight(aspect.planetA, aspect.planetB);
      
      if (aspect.aspect.nature === 'harmonious') {
        score += 3 * weight;
      } else if (aspect.aspect.nature === 'challenging') {
        score -= 1.5 * weight;
      } else if (aspect.aspect.name === '合相') {
        score += 2 * weight;
      }
    });
    
    if (elementCompatibility.isCompatible) {
      score += 5;
    }
    
    return Math.max(40, Math.min(99, Math.round(score)));
  }

  /**
   * 获取相位权重
   */
  function getAspectWeight(planet1, planet2) {
    const importantPlanets = ['Sun', 'Moon', 'Venus', 'Mars', 'ASC', 'MC'];
    const p1Important = importantPlanets.includes(planet1);
    const p2Important = importantPlanets.includes(planet2);
    
    if (p1Important && p2Important) return 2;
    if (p1Important || p2Important) return 1.5;
    return 1;
  }

  /**
   * 计算当前行运
   */
  function calculateTransits(natalChart, transitDate = new Date()) {
    const transitPositions = calculatePlanetPositions(transitDate);
    const transits = [];
    
    const transitPlanets = ['Jupiter', 'Saturn', 'Uranus', 'Neptune', 'Pluto'];
    
    transitPlanets.forEach(transitPlanet => {
      const transitLong = transitPositions[transitPlanet];
      if (typeof transitLong !== 'number' || isNaN(transitLong)) return;
      
      // 与本命行星
      Object.entries(natalChart.planetPositions).forEach(([natalPlanet, natalLong]) => {
        if (typeof natalLong !== 'number' || isNaN(natalLong)) return;
        
        const aspectResult = calculateAspect(transitLong, natalLong);
        if (aspectResult && ['major', 'harmonious', 'challenging'].includes(aspectResult.aspect.nature)) {
          transits.push({
            transitPlanet,
            transitLongitude: transitLong,
            natalPlanet,
            natalLongitude: natalLong,
            ...aspectResult
          });
        }
      });
      
      // 与本命四轴
      ['ASC', 'MC'].forEach(axis => {
        const natalLong = axis === 'ASC' 
          ? natalChart.ascendant.longitude 
          : natalChart.midheaven.longitude;
        
        const aspectResult = calculateAspect(transitLong, natalLong);
        if (aspectResult) {
          transits.push({
            transitPlanet,
            transitLongitude: transitLong,
            natalPlanet: axis,
            natalLongitude: natalLong,
            ...aspectResult
          });
        }
      });
    });
    
    // 排序
    transits.sort((a, b) => getTransitImportance(b) - getTransitImportance(a));
    
    return {
      date: transitDate,
      transitPositions,
      transits,
      majorTransits: transits.filter(t => getTransitImportance(t) >= 3)
    };
  }

  /**
   * 获取行运重要性
   */
  function getTransitImportance(transit) {
    let importance = 0;
    
    if (['Pluto', 'Neptune', 'Uranus'].includes(transit.transitPlanet)) {
      importance += 3;
    } else if (['Saturn', 'Jupiter'].includes(transit.transitPlanet)) {
      importance += 2;
    }
    
    if (['Sun', 'Moon', 'ASC', 'MC'].includes(transit.natalPlanet)) {
      importance += 2;
    }
    
    if (transit.orb < 2) {
      importance += 2;
    } else if (transit.orb < 5) {
      importance += 1;
    }
    
    return importance;
  }

  // ============ 导出 ============

  global.AstroCalculator = {
    calculateNatalChart,
    calculateSynastry,
    calculateTransits,
    
    longitudeToSign,
    formatDegree,
    calculateAspect,
    calculateAllAspects,
    calculatePlanetPositions,
    
    ZODIAC_SIGNS,
    PLANETS,
    ASPECTS,
    HOUSES,
    PLANET_MEANINGS
  };

})(typeof window !== 'undefined' ? window : global);